import { createBillingHistoryRecord as createBillingHistoryApi } from '../../api/subscriptions/subscriptions';

export const createBillingHistoryRecord = async (billingData) => {
  if (!billingData?.companyId) {
    throw new Error('companyId is required');
  }
  return createBillingHistoryApi({
    companyId: billingData.companyId,
    billing: billingData,
  });
};

export const formatBillingAmount = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(amount);
};

export const formatBillingDate = (date) => {
  try {
    if (date?.toDate) {
      return date.toDate().toLocaleDateString();
    }
    if (typeof date === 'string') {
      return new Date(date).toLocaleDateString();
    }
    if (date instanceof Date) {
      return date.toLocaleDateString();
    }
    if (typeof date === 'number') {
      return new Date(date * 1000).toLocaleDateString();
    }
    return 'N/A';
  } catch (err) {
    console.error('Error formatting billing date:', err);
    return 'N/A';
  }
};
